// services/businessService.js
import apiClient from './api'

const BusinessService = {
  /**
   * Fetches the business status (counts vs. limits)
   * @param {string} businessId - The public_id of the business.
   * @returns {Promise<object>} - The business status data.
   */
  getStatus(businessId) {
    return apiClient
      .get(`/business/${businessId}/status/`)
      .then((response) => response.data)
  },

  /**
   * Marks the initial business setup as complete.
   * @param {string} businessId - The public_id of the business.
   * @returns {Promise<object>} - The confirmation status.
   */
  completeSetup(businessId) {
    // This POST request hits the 'CompleteSetupAPIView' endpoint.
    // It doesn't need to send any data in its body.
    return apiClient
      .post(`/business/${businessId}/complete-setup/`)
      .then((response) => response.data)
  },
}

export default BusinessService
